export function vsearchRequestKey(searchTerm, soldQuery) {
	return `${String(searchTerm).toLowerCase()}|${soldQuery}`;
}

export function createVsearchGate() {
	let generation = 0;
	let inflightKey = null;

	return {
		begin(key) {
			if (inflightKey === key) {
				return { started: false, generation };
			}
			generation += 1;
			inflightKey = key;
			return { started: true, generation };
		},
		settle(key) {
			if (inflightKey === key) {
				inflightKey = null;
			}
		},
		isCurrent(seen) {
			return seen === generation;
		},
	};
}
